const PAYLUDD_BENEFICIARIES = {
    PAYLUDD_BENEFICIARIES: {
        url: '/contractsAccesses/:contractAccessId/payluddBeneficiaries',
        queryKey: 'getPayluddBeneficiaries'
    },
    UPDATE_PAYLUDD_BENEFICIARY: {
        url: '/contractsAccesses/:contractAccessId/payluddBeneficiary/:beneficiaryUuid'
    },
    CREATE_PAYLUDD_BENEFICIARY: {
        url: '/contractsAccesses/:contractAccessId/payluddBeneficiary'
    },
    DELETE_PAYLUDD_BENEFICIARY: {
        url: '/contractsAccesses/:contractAccessId/payluddBeneficiary/:beneficiaryUuid'
    }
};

export default PAYLUDD_BENEFICIARIES;